var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51.18 40.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{font-size:31.6px;font-family:MyriadPro-Regular, Myriad Pro;}.cls-3,.cls-4{fill:#442c5c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 51.18,
    height: 40.99
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(18.02 28.19) scale(1.18 1)"
  }, "?"), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.47,32.45H1.71V1.71H49.47Zm-18.76,6v.86H20.47v-.86h4.27V34.16h1.7v4.27ZM50.33,0H.85A.85.85,0,0,0,0,.85V33.31a.85.85,0,0,0,.85.85H23v2.56H18.77V41H32.41V36.72H28.15V34.16H50.33a.85.85,0,0,0,.85-.85V.85A.85.85,0,0,0,50.33,0",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPic);
export default __webpack_public_path__ + "static/media/noPic.e67923ff567006df3004fe96ad93acb6.svg";
export { ForwardRef as ReactComponent };